import { gql } from '@apollo/client'

export const REMOVE_PRICE_LIST = gql`
  mutation destroyPricingPlan($id: ID!) {
    destroyPricingPlan(input: { id: $id }) {
      success
      errors
    }
  }
`
